'use strict';
const formValidation = require('base/components/formValidation.js');
const utils = require('../util/utils.js');

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - <optional> button that was clicked for email sign-up from footer
 * @param {boolean} modal - <optional> Shows if the function is called from a modal
 * @param {boolean} isSms - <optional> Shows if the function is called from the SMS input
 */
function displayMessage(data, button, modal, isSms) {
    $.spinner().stop();
    var status = data.success ? 'alert-success' : 'alert-danger';
    if (modal) {
        $('.email-optin-signup-message').append('<div class="email-signup-alert text-center ' + status + '">' + data.msg + '</div>');
    } else if (isSms) {
        $('.sms-signup-message').append('<div class="email-signup-alert text-center ' + status + '">' + data.msg + '</div>');
    } else {
        $('.email-signup-message').append('<div class="email-signup-alert text-center ' + status + '">' + data.msg + '</div>');
    }
    setTimeout(function () {
        button.removeAttr('disabled');
        if (modal) {
            $('.email-optin-signup-message .email-signup-alert').remove();
            if (data.success) {
                if ($('.email-optin-modal .step-1').hasClass('d-none')) {
                    $('.email-optin-modal .step-2').addClass('d-none');
                    $('.modal-email-optin').trigger('modal:dismiss');
                } else {
                    $('.email-optin-modal .step-1').addClass('d-none');
                    $('.email-optin-modal .step-2').removeClass('d-none');
                }
            }
        } else {
            $('.email-signup-alert').remove();
            if (data.success) {
                $('input[name=hpEmailSignUp]').val('');
                $('input[name=hpSMSSignUp]').val('');
            }
        }
    }, 3000);
}

/**
 * Checks if the phoneNumber value entered is correct format
 * @param {string} phoneNumber - phoneNumber string to check if valid
 * @returns {boolean} Whether phoneNumber is valid
 */
function validatePhoneNumber(phoneNumber) {
    var regex = /[0-9]{10,11}/;
    return regex.test(phoneNumber);
}

module.exports = function () {
    $('.subscribe-email').on('click', function (e) {
        e.preventDefault();
        var url = $(this).data('href');
        var button = $(this);
        var emailId = $('input[name=hpEmailSignUp]').val();
        var siteId = $(this).data('site');
        var result = {
            emailId: emailId,
            optins: {}
        };
        result.optins[siteId] = true;

        $.spinner().start();
        $(this).attr('disabled', true);
        $('.subscribe-email').trigger('subscribe:email', e);
        $.ajax({
            url: url,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(result),
            success: function (data) {
                displayMessage(data, button);
                $('.subscribe-email').trigger('subscribe:email:success', data);
            },
            error: function (err) {
                displayMessage(err, button);
            }
        });
    });

    $('#hpSMSSignUp').on('change', function () {
        var tel = this.value;
        tel = tel.replace(/\D+/g, '');
        this.value = tel;
    });

    $('.subscribe-sms').on('click', function (e) {
        e.preventDefault();
        var url = $(this).data('href');
        var button = $(this);
        var phoneId = $('input[name=hpSMSSignUp]').val();
        var shortCode = $('input[name=shortCode]').val();
        var messageText = $('input[name=messageText]').val();
        var mid = $('input[name=mid]').val();
        var result = {
            phone: phoneId,
            shortCode: shortCode,
            mid: mid,
            messageText: messageText
        };

        $.spinner().start();
        $(this).attr('disabled', true);
        $('.subscribe-sms').trigger('subscribe:sms', e);
        $.ajax({
            url: url,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(result),
            success: function (data) {
                displayMessage(data, button, false, true);
                $('.subscribe-sms').trigger('subscribe:sms:success', data);
            },
            error: function (err) {
                displayMessage(err, button, false, true);
            }
        });
    });

    let themeId = $('.email-optin-modal').data('theme');

    setTimeout(() => {
        if (!utils.getCookie('optin-modal-' + themeId)) {
            $('.email-optin-modal').addClass('show');
        }
    }, [1000]);

    $('.modal-email-optin .close, .modal-email-optin .consent-decline').on('click', function () {
        $('.modal-email-optin').trigger('modal:dismiss');
    });

    $('.modal-email-optin').on('modal:dismiss', function () {
        $('.email-optin-modal').removeClass('show');
        utils.setCookie('optin-modal-' + themeId, new Date().getTime(), 365);
    });

    $('form.emailoptin-form').on('submit', function (e) {
        e.preventDefault();
        var $form = $(this);
        var url = $form.attr('action');
        var button = $('button[name="email-optin-sign-up"]');

        var result = {
            emailId: $('input[name=optin-email]').val(),
            optins: {
                rawlings: $('input[name=optins-rawlings]').is(':checked'),
                easton: $('input[name=optins-easton]').is(':checked'),
                miken: $('input[name=optins-miken]').is(':checked'),
                worth: $('input[name=optins-worth]').is(':checked')
            },
            interests: {
                baseball: $('input[name=optins-baseball]').is(':checked'),
                fastpitch: $('input[name=optins-fastpitch]').is(':checked'),
                slowpitch: $('input[name=optins-slowpitch]').is(':checked')
            }
        };

        $('.modal-content').spinner().start();
        button.attr('disabled', true);
        $.ajax({
            url: url,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(result),
            success: function (data) {
                $('.modal-content').spinner().stop();
                displayMessage(data, button, true);
                $('.emailoptin-form').trigger('modal-optin:email:success', data);
            },
            error: function (err) {
                $('.modal-content').spinner().stop();
                displayMessage(err, button, true);
            }
        });
    });

    $('form.phonenumber-optin-form').on('submit', function (e) {
        e.preventDefault();
        var $form = $(this);
        var url = $form.attr('action');
        var button = $('button.email-optin-number-sign-up');
        var phoneNumber = $('input[name=optins-phonenumber]').val().replace(/[^0-9]/g, '');
        var phoneError = $('input[name=optins-phonenumber]').data('pattern-mismatch');

        if (!validatePhoneNumber(phoneNumber)) {
            formValidation($form, {
                fields: {
                    'optins-phonenumber': phoneError
                }
            });
            return;
        }

        var result = {
            emailId: $('input[name=optin-email]').val(),
            phone: phoneNumber,
            optins: {
                rawlings: $('input[name=optins-rawlings]').is(':checked'),
                easton: $('input[name=optins-easton]').is(':checked'),
                miken: $('input[name=optins-miken]').is(':checked'),
                worth: $('input[name=optins-worth]').is(':checked')
            },
            interests: {
                baseball: $('input[name=optins-baseball]').is(':checked'),
                fastpitch: $('input[name=optins-fastpitch]').is(':checked'),
                slowpitch: $('input[name=optins-slowpitch]').is(':checked')
            }
        };

        $('.modal-content').spinner().start();
        button.attr('disabled', true);
        $.ajax({
            url: url,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(result),
            success: function (data) {
                $('.modal-content').spinner().stop();
                displayMessage(data, button, true);
            },
            error: function (err) {
                $('.modal-content').spinner().stop();
                displayMessage(err, button, true);
            }
        });
    });
};
